var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobCreditAmount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18547",
    transform: "translate(-480 -520)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 993",
    cx: 32,
    cy: 32,
    r: 32,
    transform: "translate(480 520)",
    style: {
      fill: "#d6f09a"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 56964",
    d: "M520.679 544.344a.619.619 0 0 0-.457-.179h-3.4a6.883 6.883 0 0 0-1.274-2.865h4.633a.611.611 0 0 0 .636-.636v-2.028a.612.612 0 0 0-.635-.636h-16.546a.612.612 0 0 0-.636.636v2.645a.645.645 0 0 0 .636.636h2.884q4.2 0 5.329 2.247h-8.213a.612.612 0 0 0-.636.636v2.029a.612.612 0 0 0 .636.636h8.492a3.886 3.886 0 0 1-2.034 2.486 8.974 8.974 0 0 1-4.226.855h-2.232a.645.645 0 0 0-.636.636v2.526a.6.6 0 0 0 .179.438q3.818 4.057 9.9 11.355a.586.586 0 0 0 .5.239h3.878a.577.577 0 0 0 .577-.358.543.543 0 0 0-.08-.676q-5.806-7.12-9.128-10.659a10.086 10.086 0 0 0 5.489-2.187 7.435 7.435 0 0 0 2.565-4.654h3.341a.613.613 0 0 0 .636-.636v-2.03a.619.619 0 0 0-.178-.456z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobCreditAmount);
export default __webpack_public_path__ + "static/media/mobCreditAmount.74174eaa11d48570f1f69e5b50025c47.svg";
export { ForwardRef as ReactComponent };